'use client'

import * as React from 'react'
import { cn } from 'app/lib/utils'
import { ChevronToggle } from 'app/components/ChevronToggle'

type ComboButtonViewProps = {
  inputClassName?: string
  customIcon?: React.ReactNode
  children: React.ReactNode
  chevronClassName?: string
  disabled?: boolean
  isOpen?: boolean
  onClick?: () => void
  ref?: React.Ref<HTMLDivElement>
}

export function ComboButtonView({
  inputClassName,
  customIcon,
  children,
  chevronClassName,
  disabled,
  isOpen,
  onClick,
  ref,
}: ComboButtonViewProps) {
  return (
    <div
      data-testid="combo-button"
      className={cn(`combobox-button group/combo-button`, inputClassName)}
      ref={ref}
      onClick={onClick}
    >
      {/* The slot keeps `min-width: auto` so a real icon never squashes below its
          intrinsic size. An empty-cell "+" chip is the one thing that must shrink
          instead, so it opts the slot in through its own data-slot. */}
      {customIcon && <span className="flex items-center has-[>[data-slot=inline-add-chip]]:min-w-0">{customIcon}</span>}
      <div
        className={cn(
          { [`!ml-2 !pr-4`]: customIcon },
          `flex w-3/4 items-center`,
          // With an "+ Verb" chip in the icon slot the control is the chip; this
          // half holds nothing but a blank value. Claiming 3/4 of the button for
          // that blank made the chip absorb its share of every shortfall, so the
          // verb truncated at any width (a 282px cell already cut "Assign" to
          // "Assig", a 130px one to "As"). `flex-1` zeroes this half's basis when
          // the chip is present, so the chip keeps its intrinsic width and only
          // gives way once the column is genuinely too narrow for it.
          `group-has-[[data-slot=inline-add-chip]]/combo-button:min-w-0 group-has-[[data-slot=inline-add-chip]]/combo-button:flex-1`,
        )}
      >
        {children}
      </div>
      {!disabled && (
        <div className="stuff-on-the-right absolute inset-y-0 right-0 flex items-center rounded-r-md">
          <ChevronToggle className={chevronClassName} open={isOpen} />
        </div>
      )}
    </div>
  )
}
